import React from 'react';
import PageHero from '../../components/PageHero';
import AnimatedSection from '../../components/AnimatedSection';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function BOP() {
  return (
    <div className="bg-white">
      <PageHero 
        title="Business Owner Policy" 
        description="The ultimate masterkey. A highly-classified, bundled package offering maximum coverage efficiency."
        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop"
      />
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <AnimatedSection>
              <div className="w-16 h-2 bg-red-600 mb-8"></div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-8 tracking-tight">The Master Strategy.</h2>
              <p className="text-zinc-600 text-xl mb-8 font-light leading-relaxed">
                Why manage multiple fragmented policies when you can deploy one dominant solution? The Business Owner's Policy (BOP) fuses our elite property and liability protections into a singular, cost-optimized fortress, tailored precisely for agile enterprises.
              </p>
              <ul className="space-y-5 mb-12">
                {['Unified Property & Liability Matrix', 'Business Income Interruption Coverage', 'Aggressive Premium Optimization', 'Surgically Customized Add-ons'].map((item, i) => (
                  <motion.li whileHover={{ x: 5 }} key={i} className="flex items-center gap-4 text-zinc-800 font-medium text-lg">
                    <div className="bg-red-50 p-2 rounded-lg text-red-600"><SafeIcon icon={FiIcons.FiPackage} /></div> {item}
                  </motion.li>
                ))}
              </ul>
              <Link to="/contact" className="inline-block bg-zinc-900 text-white px-8 py-4 rounded-full font-bold hover:bg-red-600 transition-colors shadow-xl uppercase tracking-wide text-sm">
                Unlock The Masterkey
              </Link>
            </AnimatedSection>
            <AnimatedSection delay={0.2} className="relative">
              <div className="absolute inset-0 bg-zinc-900 -translate-x-4 -translate-y-4 rounded-3xl"></div>
              <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2026&auto=format&fit=crop" alt="Business Planning" className="relative z-10 rounded-3xl shadow-2xl w-full h-[600px] object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
}